import type { ComponentType } from 'react'

import { Booking } from '@views/booking/booking'
import { BookingArrivalDepartures } from '@views/booking_arrival_departures/booking_arrival_departures'
import { BookingConfirmation } from '@views/booking_confirmation/booking_confirmation'
import { ContactToBook } from '@views/contact_to_book/contact_to_book'
import { DatesSelection } from '@views/dates_selection/dates_selection'
import { DetailsPolicies } from '@views/details_policies/details_policies'
import { VerificationModal } from '@views/details_policies/verification_modal'
import { GroomingWizard } from '@views/grooming_wizard/groomer_wizard'
import { HomePage } from '@views/home_page'
import { NotFound } from '@views/not_found/not_found'
import { Payment } from '@views/payment'
import { PrivacyPolicy } from '@views/privacy_policy/privacy_policy'
import { Agreements } from '@views/profile/agreements/agreements'
import { Contracts } from '@views/profile/agreements/contracts'
import { Bookings } from '@views/profile/bookings/bookings'
import { Cameras } from '@views/profile/cameras/cameras'
import { ProfileContactsAdd, ProfileContactsEdit } from '@views/profile/contacts/form'
import { ProfileContactsList } from '@views/profile/contacts/list'
import { Memberships } from '@views/profile/memberships/memberships'
import { MyProfileEdit } from '@views/profile/myprofile/edit'
import { MyProfile } from '@views/profile/myprofile/myprofile'
import { ProfilePackages } from '@views/profile/packages/list'
import { PaymentWallet } from '@views/profile/payment/payment'
import { MyPetsAdd, MyPetsEdit } from '@views/profile/pets/form'
import { MyPets } from '@views/profile/pets/list'
import { ReportCards } from '@views/profile/report_cards/report_cards'
import { WaitlistRecords } from '@views/profile/waitlist_records/waitlist_records'
import { PurchaseHistory } from '@views/purchase_history/purchase_history'
import { PurchaseSummary } from '@views/purchase_summary/purchase_summary'
import { RedirectPage } from '@views/redirect_page/redirect_page'
import { SearchOffers } from '@views/search_offers/search_offers'
import { SearchPetAddOns } from '@views/search_pet_addons/search_pet_addons'
import { SearchRoomAddOns } from '@views/search_room_addons/search_room_addons'
import { SignIn } from '@views/signin/signin'
import { TemperTest } from '@views/temper_test/temper_test'
import { Waitlist } from '@views/waitlist/waitlist'
import { RedirectWithParams } from 'components-ui/src/shared/routes'
import type { TRouteNames } from './types'

// Each route definition must have a component here; all pages remain eagerly imported.
export const routeComponents = {
  homePage: HomePage,
  locationHome: RedirectPage,
  signIn: SignIn,
  searchServiceType: Booking,
  searchOffersResults: SearchOffers,
  searchRoomAddOns: SearchRoomAddOns,
  searchPetAddOns: SearchPetAddOns,
  bookingArrivalDepartures: BookingArrivalDepartures,
  loginCheck: VerificationModal,
  detailsPolicies: DetailsPolicies,
  waitlistConfirm: Waitlist,
  contactToBook: ContactToBook,
  purchaseHistory: PurchaseHistory,
  purchaseSummary: PurchaseSummary,
  purchaseHistory_legacy: () => (
    <RedirectWithParams to={(params) => `/${params.accountName}/account/bookings/purchases`} />
  ),
  purchaseSummary_legacy: () => (
    <RedirectWithParams to={(params) => `/${params.accountName}/account/bookings/${params.bookingId}`} />
  ),
  purchaseSummaryCancel_legacy: () => (
    <RedirectWithParams to={(params) => `/${params.accountName}/account/bookings/${params.bookingId}`} />
  ),
  rest_legacy: () => <RedirectWithParams to={(params) => `/${params.accountName}`} />,
  datesSelection: DatesSelection,
  temperTest: TemperTest,
  groomingWizard: GroomingWizard,
  paymentForm: Payment,
  paymentSummary: BookingConfirmation,
  privacyPolicy: PrivacyPolicy,
  profile: () => <RedirectWithParams to={(params) => `/${params.accountName}/profile/my-profile`} />,
  myprofile: MyProfile,
  myprofileEdit: MyProfileEdit,
  profilePet: MyPets,
  profilePetEdit: MyPetsEdit,
  profilePetAdd: MyPetsAdd,
  profileCameras: Cameras,
  profileBookings: Bookings,
  profileWaitlist: WaitlistRecords,
  profileReportCards: ReportCards,
  profilePayments: PaymentWallet,
  profileMemberships: Memberships,
  profilePackages: ProfilePackages,
  profileAgreements: Agreements,
  profileContracts: Contracts,
  profileContacts: ProfileContactsList,
  profileContactsEdit: ProfileContactsEdit,
  profileContactsAdd: ProfileContactsAdd,
  notFound: NotFound,
} satisfies Record<TRouteNames, ComponentType>
